module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [(_vm.brandBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        return _vm.queryChange($event, 'brand_id')
      }
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brandSelect.value !== 0 && _vm.brandSelect.value !== '0' && _vm.storeBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        return _vm.queryChange($event, 'store_id')
      }
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deTypeSelect),
      expression: "deTypeSelect"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        return _vm.queryChange($event, 'delivery_type')
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.deliveryTypeList), function(item) {
    return _c('option', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.value !== 21) || (item.value === 21 && _vm.$route.name !== 'onSiteOrderTable')),
        expression: "(item.value !== 21) || (item.value === 21 && $route.name !== 'onSiteOrderTable')"
      }],
      key: item.value,
      domProps: {
        "value": item.value,
        "textContent": _vm._s(item.label)
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        return _vm.queryChange($event, 'status')
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.statusList), function(status) {
    return _c('option', {
      domProps: {
        "value": status.value,
        "textContent": _vm._s(status.label)
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trTypeSelect),
      expression: "trTypeSelect"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        return _vm.queryChange($event, 'trade_type')
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getTradeType), function(trade) {
    return _c('option', {
      domProps: {
        "value": trade.value,
        "textContent": _vm._s(trade.label)
      }
    })
  }), 0)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        return _vm.queryChange($event, 'search_select')
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("時間")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("訂購者")]), _vm._v(" "), (!_vm.isGuestTab) ? _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("最低跟團人數")]) : _vm._e()])]), _vm._v(" "), (_vm.searchSelect == 1) ? _c('div', {
    staticClass: "form-group input-group time-box"
  }, [(!_vm.isLoading) ? _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "enabled": _vm.isLoading,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    },
    on: {
      "change": function($event) {
        return _vm.queryChange($event, 'start_time')
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuTime.start.time),
      expression: "menuTime.start.time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "placeholder": "起始時間"
    },
    domProps: {
      "value": (_vm.menuTime.start.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.menuTime.start, "time", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    },
    on: {
      "change": function($event) {
        return _vm.queryChange($event, 'end_time')
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuTime.end.time),
      expression: "menuTime.end.time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "placeholder": "結束時間"
    },
    domProps: {
      "value": (_vm.menuTime.end.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.menuTime.end, "time", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "type": "button",
      "id": "search"
    },
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.searchSelect == 2) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderSn),
      expression: "orderSn"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.orderSn)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.orderSn = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'order_sn')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect == 3) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopper),
      expression: "shopper"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.shopper)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.shopper = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'shopper_name')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect == 4) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subOrderAmount),
      expression: "subOrderAmount"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.subOrderAmount)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.subOrderAmount = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'sub_order_amount')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(4)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e()])]), _vm._v(" "), (_vm.isOnline) ? _c('div', {
    staticStyle: {
      "height": "35px"
    }
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.typeSelect === 99
    },
    attrs: {
      "role": "presentation"
    }
  }, [(!_vm.isLoading) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typeSelect = 99
      }
    }
  }, [_vm._v("全部\n          ")]) : _c('a', {
    staticClass: "filter-load"
  }, [_vm._v("全部")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.typeSelect === 1
    },
    attrs: {
      "disabled": _vm.isLoading,
      "role": "presentation"
    }
  }, [(!_vm.isLoading) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typeSelect = 1
      }
    }
  }, [_vm._v("一般單\n          ")]) : _c('a', {
    staticClass: "filter-load"
  }, [_vm._v("一般單")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.typeSelect === 2
    },
    attrs: {
      "disabled": _vm.isLoading,
      "role": "presentation"
    }
  }, [(!_vm.isLoading) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typeSelect = 2
      }
    }
  }, [_vm._v("團購單\n          ")]) : _c('a', {
    staticClass: "filter-load"
  }, [_vm._v("團購單")])])])])]) : _c('div', {
    staticStyle: {
      "height": "35px"
    }
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.$route.name === 'onSiteOrderMemberTable'
    },
    attrs: {
      "disabled": _vm.isLoading,
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "replace": "",
      "to": {
        path: '/onSiteOrderTable/member',
        query: _vm.$route.query
      }
    }
  }, [_vm._v("會員單")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.name === 'onSiteOrderGuestTable'
    },
    attrs: {
      "disabled": _vm.isLoading,
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "replace": "",
      "to": {
        path: '/onSiteOrderTable/guest',
        query: _vm.$route.query
      }
    }
  }, [_vm._v("訪客單")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "download-block"
  }, [_c('div', [_vm._v("每個檔案最多" + _vm._s(this.exportMaxLimit) + "筆資料，超過上限會分成數個檔案下載。"), _c('span', {
    staticClass: "text-bold"
  }, [_vm._v("（ 目前資料筆數：" + _vm._s(this.total) + " ）")])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('button', {
    staticClass: "btn btn-default btn-table-title z-100",
    attrs: {
      "disabled": _vm.isDownloading || _vm.isLoading
    },
    on: {
      "click": _vm.exportFile
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("下載報表\n          "), _c('Clip', {
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.isDownloading,
      "color": '#528BB8',
      "size": '16px'
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0 p-b-20"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [(_vm.isGuestTab) ? _c('span', [_vm._v("POS機")]) : _vm._e(), _vm._v("訂單編號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單類型")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌(ID)")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("分店(ID)")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂購人"), (_vm.isGuestTab) ? _c('span', [_vm._v("姓名")]) : (_vm.roleType === 99) ? _c('span', [_vm._v("(ID)")]) : _vm._e()]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("總數")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("實付金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("付款狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v(_vm._s(_vm.isGuestTab ? '訂單建立時間' : '下訂時間'))]), _vm._v(" "), (_vm.isOnline) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n            追蹤碼\n            "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(0)], 1)]) : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(1)]) : (!_vm.isLoading && _vm.orderList.length > 0) ? _c('tbody', _vm._l((_vm.orderList), function(order, index) {
    return _c('tr', {
      staticClass: "even",
      class: {
        'bg-pre-order': order.order_method === 2
      },
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (!_vm.isGuestTab) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: _vm.isOffline ? '/onSiteOrderTableInfo/' + order.order_id : '/orderInfo/' + order.order_id
        },
        "target": "_blank"
      }
    }, [_vm._v("\n              " + _vm._s(order.order_sn) + "\n            ")]), _vm._v(" \n            ")], 1) : _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/onSiteOrderTableInfo/' + order.shipping_case_id + '?is_guest=1'
        },
        "target": "_blank"
      }
    }, [_vm._v("\n              " + _vm._s(order.pos_order_sn) + "\n            ")]), _vm._v(" \n            ")], 1), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm.orderStateColor(order.status)
    }, [_vm._v(_vm._s(_vm.orderState(order.status)))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline-block",
      staticStyle: {
        "width": "22px"
      }
    }, [(order.delivery_type === 1) ? _c('i', {
      staticClass: "fa fa-hand-paper-o",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (order.delivery_type === 2) ? _c('i', {
      staticClass: "fa fa-inbox",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (order.delivery_type === 3) ? _c('i', {
      staticClass: "fa fa-motorcycle",
      class: _vm.shippingStateColor(order.shipping_case_status),
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "mouseover": function($event) {
          return _vm.selectStyle(order)
        },
        "mouseout": function($event) {
          return _vm.outStyle(order)
        }
      }
    }) : _vm._e(), _vm._v(" "), (order.delivery_type === 4) ? _c('i', {
      staticClass: "fa fa-shopping-bag",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (order.delivery_type === 5) ? _c('i', {
      staticClass: "fa fa-glass",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (order.delivery_type === 21) ? _c('i', {
      staticClass: "fa fa-qrcode",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (order.active),
        expression: "order.active"
      }],
      staticClass: "shipping-state-label",
      class: _vm.shippingStateColorBg(order.shipping_case_status)
    }, [_vm._v("\n                " + _vm._s(_vm.shippingState(order.shipping_case_status)) + "\n              ")])]), _vm._v(" \n            "), (order.order_type === 1) ? _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("一般")]) : _vm._e(), _vm._v(" "), (order.order_type === 2) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("團購"), (order.sub_order_amount) ? _c('span', [_vm._v(_vm._s(order.sub_order_amount) + "人跟")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (order.src_type === 1) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("P")]) : _vm._e(), _vm._v(" "), (order.src_type === 2) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("D")]) : _vm._e(), _vm._v(" "), (order.src_type === 3) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("PL")]) : _vm._e(), _vm._v(" "), (order.src_type === 4) ? _c('span', {
      staticClass: "text-12 text-w-600 label-warning",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("DL")]) : _vm._e(), _vm._v(" "), (order.src_type === 6) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("A")]) : _vm._e(), _vm._v(" "), (order.sub_src_type === 1) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("W")]) : (order.sub_src_type === 2) ? _c('span', {
      staticClass: "text-12 text-w-600 label-success",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("L")]) : (order.sub_src_type === 3) ? _c('span', {
      staticClass: "text-12 text-w-600 label-primary",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("M")]) : (order.sub_src_type === 4) ? _c('span', {
      staticClass: "text-12 text-w-600 label-success",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("LI")]) : (order.sub_src_type === 5) ? _c('span', {
      staticClass: "text-12 text-w-600 label-danger",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("J")]) : _vm._e()]), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(order.brand_name) + "(" + _vm._s(order.brand_id) + ")")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('td', [_vm._v(_vm._s(order.store_name) + "(" + _vm._s(order.store_id) + ")")]) : _vm._e(), _vm._v(" "), _c('td', [(_vm.isGuestTab) ? _c('span', [_vm._v("\n              " + _vm._s(order.name) + "\n            ")]) : ((_vm.roleType === 30 || _vm.roleType === 99) && _vm.$route.name !== 'memberOrderTable' && _vm.checkMemberShow(order.status) && _vm.isOnline) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/memberOrderTable/' + order.shopper_id
        },
        "target": "_blank"
      }
    }, [_vm._v("\n              " + _vm._s(order.name) + "\n              "), (_vm.roleType === 99) ? _c('span', [_vm._v("\n                (" + _vm._s(order.shopper_id) + ")\n              ")]) : _vm._e()]) : _c('span', [_vm._v("\n              " + _vm._s(order.name) + "\n              "), (_vm.roleType === 99) ? _c('span', [_vm._v("\n                (" + _vm._s(order.shopper_id) + ")\n              ")]) : _vm._e()]), _vm._v(" "), (order.main_shopper_id) ? _c('span', {
      staticClass: "tag-default text-white bg-blue",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": 'ID(' + order.main_shopper_id + ')'
      }
    }, [_vm._v("主")]) : _vm._e(), _vm._v(" "), (order.sub_shopper_id) ? _c('span', {
      staticClass: "tag-default text-white bg-orange",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": 'ID(' + order.sub_shopper_id + ')'
      }
    }, [_vm._v("副")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.amount))]), _vm._v(" "), (_vm.isOffline) ? _c('td', [_c('span', {
      class: {
        'text-del': _vm.hasPaidMoneyChanged(order)
      }
    }, [_vm._v("＄" + _vm._s(order.money) + " ")]), _vm._v(" "), (_vm.hasPaidMoneyChanged(order)) ? _c('span', {
      staticClass: "text-red"
    }, [_vm._v("＄" + _vm._s(order.paid_money))]) : _vm._e()]) : _c('td', [_c('span', {
      class: {
        'text-del': order.paid_money !== order.money + order.shipping_money
      }
    }, [_vm._v("＄" + _vm._s(order.money + order.shipping_money) + " ")]), _vm._v(" "), (order.paid_money !== order.money + order.shipping_money) ? _c('span', {
      staticClass: "text-red"
    }, [_vm._v("＄" + _vm._s(order.paid_money))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm.stateColor(order.payment_status)
    }, [_vm._v("\n              " + _vm._s(_vm._f("tradeName")(order.trade_type)) + " " + _vm._s(_vm.payStateName(order.payment_status)) + "\n            ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.isGuestTab ? _vm.getTime(order.create_time) : _vm.getTime(order.order_time)))]), _vm._v(" "), (_vm.isOnline) ? _c('td', [_vm._v(_vm._s(order.src_vendor_code))]) : _vm._e()])
  }), 0) : (!_vm.isLoading && _vm.orderList.length === 0) ? _c('tbody', [_vm._m(2)]) : _vm._e()])]), _vm._v(" "), (!_vm.orderList.length && _vm.$route.name === 'onSiteOrderTableInfo') ? _c('div', {
    staticClass: "text-center m-a-100 text-light-gray"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "m-t-5"
  }, [_vm._v("沒有符合的資料")])]) : _vm._e(), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.changePage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n                「你訂團隊持續在進行系統優化，如有追蹤訂單來源需求，可自【新後台管理系統】-【成效數據中心】使用[自訂報表]下載報表分析。\n                "), _c('br'), _vm._v("\n                此追蹤碼功能於近期將不再進行相關維護，如需更進階數據分析需求，可洽你訂同仁詢問GA4數據分析，會有專人與您詳細說明完整方案。」\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "font-size-80"
  }, [_c('i', {
    staticClass: "ion ion-clipboard"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2b992de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Order/Temp/OrderTableTemp.vue
// module id = 2557
// module chunks = 1